import TechnicianOvertimeExport from "../data/technician/TechnicianOvertimeExport";

interface OvertimeExportDrawerProps {
  technicianId?: string;
}

export function OvertimeExportDrawer({ technicianId }: OvertimeExportDrawerProps) {
  return (
    <div className="p-4 h-[90%]">
      <TechnicianOvertimeExport technicianId={technicianId} />
    </div>
  );
} 